import React from "react";
import GrowthBadge from "./GrowthBadge";
import { T } from "../../constants/theme";

/** Leaderboard row */
const LeaderboardRow = ({ rank, label, value, sub, growth, color, isTop, loading }) => (
  <div className="sad-leaderboard-row">
    <div
      className="sad-rank-dot"
      style={{ background: isTop ? T.yellow : T.light, color: isTop ? "#fff" : T.muted }}
    >
      {rank}
    </div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div
        style={{
          fontSize: "12px",
          fontWeight: 600,
          color: T.text,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: "10px", color: T.muted }}>{sub}</div>
    </div>
    <div style={{ textAlign: "right", flexShrink: 0 }}>
      <div style={{ fontSize: "13px", fontWeight: 700, color }}>{loading ? "…" : value}</div>
      <GrowthBadge value={growth} />
    </div>
  </div>
);

export default LeaderboardRow;
